// PokeLine Navigation — v3 (2026-07)
(function () {
  'use strict';

  // ── HEADER HEIGHT CSS VAR ────────────────────────────────────
  function setHeaderH() {
    var h = (document.querySelector('.pl-ticker')?.offsetHeight || 0) +
            (document.querySelector('.pl-header')?.offsetHeight || 0);
    document.documentElement.style.setProperty('--header-h', h + 'px');
  }
  setHeaderH();
  window.addEventListener('resize', setHeaderH);
  window.addEventListener('load', setHeaderH);

  // ── MOBILE NAV ───────────────────────────────────────────────
  var _origBurger = document.getElementById('plBurger');
  var burger = _origBurger ? (function () {
    var b = _origBurger.cloneNode(true);
    _origBurger.parentNode.replaceChild(b, _origBurger);
    return b;
  })() : null;
  var mobileNav = document.getElementById('plMobileNav');
  var mobileBackdrop = document.getElementById('plBackdrop');

  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('open');
    mobileBackdrop && mobileBackdrop.classList.remove('open');
    burger && burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  function toggleMobileNav(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var isOpen = mobileNav ? mobileNav.classList.toggle('open') : false;
    mobileBackdrop && mobileBackdrop.classList.toggle('open', isOpen);
    burger && burger.setAttribute('aria-expanded', String(isOpen));
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  if (burger) {
    burger.addEventListener('click', toggleMobileNav, { capture: true });
    burger.addEventListener('touchend', function (e) {
      e.preventDefault();
      toggleMobileNav(e);
    }, { passive: false });
  }
  mobileBackdrop && mobileBackdrop.addEventListener('click', closeMobileNav);
  mobileNav && mobileNav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMobileNav);
  });

  // ── DESKTOP MEGA MENU ────────────────────────────────────────
  function initMegaMenu() {
    var megas = document.querySelectorAll('.pl-mega');
    if (!megas.length) return;
    megas.forEach(function (mega) {
      var trigger = mega.querySelector('.pl-mega__trigger');
      if (!trigger || trigger.dataset.plInit) return;
      var freshTrigger = trigger.cloneNode(true);
      trigger.parentNode.replaceChild(freshTrigger, trigger);
      freshTrigger.dataset.plInit = '1';
      freshTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !mega.classList.contains('is-open');
        megas.forEach(function (m) {
          m.classList.remove('is-open');
          var t = m.querySelector('.pl-mega__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          mega.classList.add('is-open');
          freshTrigger.setAttribute('aria-expanded', 'true');
        }
      }, { capture: true });
    });
    if (!document._plMegaClickBound) {
      document._plMegaClickBound = true;
      document.addEventListener('click', function () {
        megas.forEach(function (m) {
          m.classList.remove('is-open');
          var t = m.querySelector('.pl-mega__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeMobileNav();
          megas.forEach(function (m) { m.classList.remove('is-open'); });
        }
      });
    }
  }
  initMegaMenu();
  window.addEventListener('load', initMegaMenu);

  // ── MOBILE ACCORDION ─────────────────────────────────────────
  document.querySelectorAll('.pl-acc').forEach(function (acc) {
    var trigger = acc.querySelector(':scope > .pl-acc__trigger');
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        acc.classList.toggle('is-open');
      });
    }
  });
  document.querySelectorAll('.pl-acc-sub').forEach(function (sub) {
    var trigger = sub.querySelector('.pl-acc-sub__trigger');
    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        sub.classList.toggle('is-open');
      });
    }
  });

  // ── PROFILE TOGGLE ───────────────────────────────────────────
  var toggleWrap = document.getElementById('profileToggle');
  if (toggleWrap) {
    toggleWrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        toggleWrap.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  }

  // ── LOTTERY SLOT GRID ────────────────────────────────────────
  var slotGrid = document.getElementById('slotGrid');
  if (slotGrid) {
    var total = 24, taken = 17, youIndex = 17;
    for (var i = 0; i < total; i++) {
      var d = document.createElement('div');
      if (i === youIndex) { d.className = 'pl-slot pl-slot--you'; d.textContent = 'TÚ'; }
      else if (i < taken) { d.className = 'pl-slot pl-slot--taken'; }
      else { d.className = 'pl-slot pl-slot--free'; }
      slotGrid.appendChild(d);
    }
  }

  // ── LOTTERY MODAL ────────────────────────────────────────────
  var modalBg = document.getElementById('modalBg');
  var modalClose = document.getElementById('modalClose');
  document.querySelectorAll('.pl-badge--lottery').forEach(function (b) {
    b.style.cursor = 'pointer';
    b.addEventListener('click', function () { modalBg && modalBg.classList.add('open'); });
  });
  if (modalClose) modalClose.addEventListener('click', function () { modalBg && modalBg.classList.remove('open'); });
  if (modalBg) modalBg.addEventListener('click', function (e) { if (e.target === modalBg) modalBg.classList.remove('open'); });

})();
